/* ============================================================
   BYG Footer 2.1 (PRÜFSTAND, Phase 9) — Werkstatt-Block.
   Zwei Aufgaben, beide progressive Enhancement (ohne JS bleibt der
   Footer voll nutzbar):

   1) Live-Status-Badge "Jetzt geöffnet / Aktuell geschlossen":
      Zeit IMMER in Europe/Vienna via Intl (unabhängig von der
      Gerätezeitzone des Besuchers). Die Öffnungszeiten kommen als
      data-zeit-1 … data-zeit-7 (ISO: 1 = Montag) aus den Section-
      Settings. Ohne JS/Intl bleibt das Badge [hidden] — kein Badge.
      Dieses Script setzt nur die Klassen --open/--closed;
      die Ampel-FARBEN (grün/rot, Anordnung Manuel Phase 9) liegen
      ausschließlich in byg-footer.css.

   2) Adresse kopieren via navigator.clipboard mit kurzem
      "Kopiert!"-Feedback. Ohne Clipboard-API (oder ohne JS) bleibt
      der Button [hidden] — kein toter Button.

   15.10.2026 — KARTE ERST NACH KLICK (Audit-Auftrag vom 15.10.2026,
   DSGVO): Das iframe steht NICHT mehr im Liquid; initMap() setzt es.
   [Klick-Gate am 17.10.2026 wieder aufgehoben, siehe nächster Absatz.]

   17.10.2026 — KARTE LÄDT AUTOMATISCH (Entscheidung Manuel: „Bitte
   automatisch laden.“). Trägt der Kartenbehälter data-byg-map-auto="1"
   (Setting karte_auto, Standard an), lädt initMap() das iframe von
   selbst, sobald der Behälter bis auf 1200 px an den Bildschirm
   heranscrollt — nicht schon beim Seitenaufruf, denn der Fuß steht auf
   jeder Seite und die Google-Karte ist das schwerste Stück darin.
   Ohne IntersectionObserver lädt sie sofort. Mit karte_auto = aus gilt
   das Klick-Gate vom 15.10.2026 unverändert weiter. Ohne JS öffnet der
   Knopf wie bisher Google Maps im neuen Tab.

   PHASE 11 — zwei Funktionen dazu, beide progressive Enhancement:

   3) SONDERZEITEN (Betriebsurlaub, Feiertag, verkürzt offen).
      Die schwerste Lücke im alten Stand: sieben Wochentags-Felder
      können keinen Urlaub abbilden, und das Schild sagt dann
      selbstbewusst "Jetzt geöffnet", während niemand da ist. Das ist
      schlimmer als gar kein Schild.
      Dafür musste viennaNow() erweitert werden — es lieferte nur
      Wochentag und Minuten, kein Datum, und ohne Datum kann man
      nichts gegen "2026-12-24" vergleichen. Und die Vorausschau
      musste von 7 auf bis zu 35 Tage: bei zwei Wochen Urlaub findet
      eine 7-Tage-Suche kein Fenster und die Auskunftszeile wäre
      genau dann leer, wenn sie am wichtigsten ist.
      Was nicht sauber zu lesen ist, wird übergangen. Fail-safe in
      diese Richtung ist Absicht: eine kaputte Zeile darf höchstens
      wirkungslos sein, nie eine falsche Auskunft erzeugen.

   4) KARTENAUSSCHNITT UMSCHALTEN (Umkreis / Zufahrt).
      Das iframe-ELEMENT wird ersetzt, nicht sein src neu gesetzt.
      Grund: eine src-Zuweisung auf ein bestehendes iframe legt einen
      Eintrag in die Sitzungs-History — der Zurück-Knopf blättert
      danach durch Kartenansichten, statt die Seite zu verlassen.
      Die Chips stehen [hidden] im Markup und werden hier
      eingeblendet. Seit 15.10.2026: solange die Karte nicht geladen
      ist, merken sie sich nur die gewählte Ansicht — geladen wird
      ausschließlich über den Knopf „Karte laden“.

   ENTFERNUNGS-CHECK WIEDER ENTFERNT (Entscheidung Manuel, R14 Punkt 6).
   Er war Punkt 5 dieser Liste. Hier FEHLT also nichts — hier ist etwas
   absichtlich weg, und es kommt nicht als „Verbesserung“ zurück.
   WARUM: gerechnet wurde gegen eine Ortstabelle im Liquid mit 41
   Einträgen / 39 verschiedenen PLZ. Jede Eingabe, die nicht darin
   stand — und das war die Mehrheit der österreichischen PLZ — endete
   mit „Diesen Ort haben wir nicht in der Liste“. Eine Auskunft, die
   meistens mit einer Entschuldigung endet, ist schlechter als keine.
   Mit raus sind auch die Hilfsfunktionen luftlinie() (Haversine),
   richtung()/HIMMEL und norm(): sie hatten ausserhalb des Checks
   keinen einzigen Aufrufer.
   NICHT VERWECHSELN: strip() weiter unten steht optisch in derselben
   Reihe und sieht wie ein Geschwister von norm() aus, hängt aber an
   parseSonder(). Ohne strip() fallen die Sonderzeiten LEISE aus — die
   Funktion ist fail-safe und zeigt dann einfach nichts an, und das
   Schild behauptet wieder „Jetzt geöffnet“, während Urlaub ist.

   Kein jQuery, keine Libraries (Leitplanken §4).
   ============================================================ */
(function () {
  'use strict';

  /* Aktuelle Zeit in Europe/Vienna: Wochentag (ISO 1–7), Minuten seit
     Mitternacht UND das Datum als JJJJ-MM-TT.
     Das Datum kam in Phase 11 dazu (Sonderzeiten). Es MUSS aus
     derselben Intl-Abfrage stammen wie Wochentag und Uhrzeit: zwei
     getrennte Abfragen können über Mitternacht auseinanderlaufen und
     ergäben dann einen Wochentag von heute mit dem Datum von gestern.
     null, wenn Intl/Timezone-Daten fehlen (sehr alte Browser). */
  function viennaNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Vienna',
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var map = {};
      for (var i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;
      var days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
      var day = days[map.weekday];
      var minutes = parseInt(map.hour, 10) * 60 + parseInt(map.minute, 10);
      if (!day || isNaN(minutes)) return null;
      var iso = null;
      if (map.year && map.month && map.day) iso = map.year + '-' + map.month + '-' + map.day;
      return { day: day, minutes: minutes, iso: iso };
    } catch (e) {
      return null;
    }
  }

  /* JJJJ-MM-TT plus n Tage, wieder als JJJJ-MM-TT.
     Gerechnet wird über Date.UTC auf 12:00 — damit kann keine
     Sommerzeitumstellung das Ergebnis um einen Tag kippen. */
  function isoPlus(iso, n) {
    var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    if (!p) return null;
    var t = Date.UTC(+p[1], +p[2] - 1, +p[3], 12, 0, 0) + n * 86400000;
    var d = new Date(t);
    var mm = d.getUTCMonth() + 1, dd = d.getUTCDate();
    return d.getUTCFullYear() + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
  }

  /* Weissraum abschneiden WIE LIQUIDS strip, also nur ASCII.
     Nicht String.prototype.trim(): das raeumt auch das geschuetzte
     Leerzeichen (U+00A0) und andere Unicode-Leerzeichen weg, Liquid
     nicht. Eine aus Word kopierte Zeile waere sonst hier gueltig und
     in den Suchmaschinen-Daten nicht — dieselbe Falle wie bei den
     Zeiten, nur in der Datumsspalte. */
  function strip(s) {
    return String(s == null ? '' : s).replace(/^[ \t\r\n\f\v\0]+/, '').replace(/[ \t\r\n\f\v\0]+$/, '');
  }

  /* Ist das ein WIRKLICH existierendes Datum?
     Die Mustererkennung allein genuegt nicht: "2026-13-99" sieht aus
     wie JJJJ-MM-TT und ist keiner. So ein Eintrag koennte zwar nie auf
     einen echten Tag passen — aber er landete im Hinweisstreifen und
     stuende dort als "99.13." vor dem Kunden.
     Geprueft wird per Rundlauf: aus den Teilen ein Datum bauen und
     sehen, ob dieselben Teile wieder herauskommen. Date normalisiert
     stillschweigend (Monat 13 wird Januar des Folgejahres) — genau
     daran faellt der Unsinn auf. Zugleich erledigt das den 30. Februar
     und den 31. April. */
  function istDatum(iso) {
    var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    if (!p) return false;
    /* Jahresschranke 2000–2099. Sie faengt den vertippten Jahrgang
       ("0226", "2206"): so ein Eintrag sieht angenommen aus, liegt
       aber Jahrzehnte weg und wirkt nie — der schlechteste aller
       Zustaende, weil niemand den Fehler bemerkt.
       Dieselbe Schranke steht in der Liquid-Prüfung des JSON-LD in
       sections/byg-footer.liquid. Die beiden MUESSEN gleich urteilen,
       sonst steht in den Suchmaschinen-Daten ein Eintrag, den die
       Seite selbst verwirft. */
    if (+p[1] < 2000 || +p[1] > 2099) return false;
    var d = new Date(Date.UTC(+p[1], +p[2] - 1, +p[3], 12, 0, 0));
    return d.getUTCFullYear() === +p[1] &&
           d.getUTCMonth() === +p[2] - 1 &&
           d.getUTCDate() === +p[3];
  }

  /* ISO-Datum -> ISO-Wochentag 1..7 (Montag = 1). */
  function isoWeekday(iso) {
    var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    if (!p) return 0;
    var g = new Date(Date.UTC(+p[1], +p[2] - 1, +p[3], 12, 0, 0)).getUTCDay();
    return g === 0 ? 7 : g;
  }

  /* "2026-12-24" -> "24.12." — die Form, in der ein Datum im Fuss
     lesbar ist. Das Jahr bleibt weg, solange es das laufende ist. */
  function kurzDatum(iso, jahrJetzt) {
    var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    if (!p) return '';
    return p[3] + '.' + p[2] + '.' + (p[1] === jahrJetzt ? '' : p[1]);
  }

  /* ---------- Sonderzeiten lesen ----------
     Eine Zeile je Eintrag, Felder mit "|":
       2026-12-24..2027-01-06 | geschlossen | Betriebsurlaub
       2026-11-01             | geschlossen | Allerheiligen
       2026-10-17             | 08:00–12:00 | verkürzt
     STRENG: was nicht genau so aussieht, fliegt raus. Kein Rateversuch,
     keine Teilauswertung — lieber kein Eintrag als ein falscher. */
  function parseSonder(raw) {
    var out = [];
    if (!raw) return out;
    var zeilen = String(raw).split(/\r?\n/);
    var dre = /^(\d{4}-\d{2}-\d{2})(?:[ \t\r\n\f\v]*\.\.[ \t\r\n\f\v]*(\d{4}-\d{2}-\d{2}))?$/;
    for (var i = 0; i < zeilen.length; i++) {
      var z = strip(zeilen[i]);
      if (!z || z.charAt(0) === '#') continue;
      var f = z.split('|');
      if (f.length < 2) continue;
      var dm = dre.exec(strip(f[0]));
      if (!dm) continue;
      var von = dm[1];
      var bis = dm[2] || von;
      if (!istDatum(von) || !istDatum(bis)) continue; /* kein echtes Datum */
      if (bis < von) continue; /* verdrehte Spanne: unbrauchbar */
      var zeit = strip(f[1]);
      var grund = f.length > 2 ? strip(f[2]) : '';
      var zu = /geschlossen/i.test(zeit);
      var ranges = zu ? [] : parseRanges(zeit);
      /* Weder "geschlossen" noch eine lesbare Zeitspanne: Zeile ist
         keine Aussage, also keine Übersteuerung. */
      if (!zu && !ranges.length) continue;
      out.push({ von: von, bis: bis, zu: zu, ranges: ranges, grund: grund });
    }
    return out;
  }

  /* Der Eintrag, der auf ein bestimmtes Datum zutrifft. Bei
     Überschneidungen gewinnt der ZULETZT eingetragene — damit kann
     Manuel einen einzelnen Tag aus einem Urlaubszeitraum
     herausnehmen, indem er ihn darunter schreibt. */
  function sonderFuer(liste, iso) {
    var hit = null;
    for (var i = 0; i < liste.length; i++) {
      if (iso >= liste[i].von && iso <= liste[i].bis) hit = liste[i];
    }
    return hit;
  }

  /* "08:00–12:00 / 13:00–17:00" → [[480,720],[780,1020]].
     Mehrere Spannen mit "/" getrennt, als Bereichstrenner –, — oder -.
     "geschlossen"/leer → [].

     VERANKERT, UND DAS IST KEINE PEDANTERIE. Dieselben Zeichenketten
     liest die Liquid-Pruefung des JSON-LD in sections/byg-footer.liquid.
     Beide MUESSEN gleich urteilen, sonst steht in den Suchmaschinen-Daten
     eine Zeit, die die Seite selbst verwirft — oder umgekehrt.
     Der frueher nicht verankerte Suchlauf nahm "Mo 08:00–12:00" und
     "08:00–12:00–17:00" an; Liquid nahm das erste an (und schrieb
     "Mo 08:00" als Uhrzeit heraus) und das zweite nicht. Jetzt fallen
     beide in beiden Lesern durch.
     Stunde 0–23 und Minute 00–59 werden zusaetzlich geprueft:
     "25:00–99:00" ist keine Zeit, auch wenn es wie eine aussieht.
     Eine Spanne, die durchfaellt, wird einzeln uebergangen — die
     uebrigen Spannen derselben Zeile bleiben gueltig. Genau so
     verfaehrt die Liquid-Seite. */
  function parseRanges(str) {
    var out = [];
    if (!str) return out;
    /* WEISSRAUM AUSDRUECKLICH ASCII, und trim() bleibt weg. \s und
       trim() in JavaScript raeumen auch das geschuetzte Leerzeichen
       (U+00A0) weg, Liquids strip nicht — eine aus Word kopierte Zeile
       waere dann im Skript gueltig und in den Suchmaschinen-Daten
       nicht. Beide verwerfen sie jetzt. */
    var re = /^[ \t\r\n\f\v]*(\d{1,2}):(\d{2})[ \t\r\n\f\v]*[–—-][ \t\r\n\f\v]*(\d{1,2}):(\d{2})[ \t\r\n\f\v]*$/;
    var teile = String(str).split('/');
    for (var i = 0; i < teile.length; i++) {
      var m = re.exec(teile[i]);
      if (!m) continue;
      var h1 = parseInt(m[1], 10), m1 = parseInt(m[2], 10);
      var h2 = parseInt(m[3], 10), m2 = parseInt(m[4], 10);
      if (h1 > 23 || h2 > 23 || m1 > 59 || m2 > 59) continue;
      out.push([h1 * 60 + m1, h2 * 60 + m2]);
    }
    return out;
  }

  /* Die Zeiten eines Tages — Sonderzeiten gehen vor Wochenzeiten.
     tag ist der ISO-Wochentag, iso das Datum. Gibt zusätzlich zurück,
     OB übersteuert wurde und mit welchem Grund: die Auskunftszeile
     formuliert danach anders ("Betriebsurlaub" statt "Ruhetag"). */
  function zeitenFuer(root, liste, tag, iso) {
    var s = iso ? sonderFuer(liste, iso) : null;
    if (s) return { ranges: s.ranges, sonder: s };
    return { ranges: parseRanges(root.getAttribute('data-zeit-' + tag) || ''), sonder: null };
  }

  function updateStatus(root) {
    var badge = root.querySelector('[data-byg-status]');
    if (!badge) return;
    var now = viennaNow();
    if (!now) return; /* Fallback: Badge bleibt versteckt */

    var sonderListe = parseSonder(root.getAttribute('data-sonderzeiten') || '');
    var heute = zeitenFuer(root, sonderListe, now.day, now.iso);
    var ranges = heute.ranges;
    var open = false;
    for (var i = 0; i < ranges.length; i++) {
      if (now.minutes >= ranges[i][0] && now.minutes < ranges[i][1]) { open = true; break; }
    }

    var textEl = badge.querySelector('[data-byg-status-text]');
    if (textEl) {
      textEl.textContent = open
        ? (badge.getAttribute('data-text-open') || '')
        : (badge.getAttribute('data-text-closed') || '');
    }
    badge.classList.toggle('byg-footer__status--open', open);
    badge.classList.toggle('byg-footer__status--closed', !open);
    badge.hidden = false;

    /* ---------- R13/P17 · DIE NAECHSTE OEFFNUNG ----------
       "Aktuell geschlossen" ist eine Feststellung, keine Auskunft. Wer
       vor dem Bildschirm sitzt, will wissen, wann er kommen kann.
       Offen  -> "bis 17:00" (Ende des laufenden Fensters)
       Zu     -> "oeffnet Do 08:00" bzw. "oeffnet um 13:00", wenn es
                 heute noch ein zweites Fenster gibt.
       Gerechnet wird ausschliesslich aus den Zeiten, die im Theme-Editor
       stehen — es gibt keine zweite Quelle, die veralten koennte.
       Sucht bis zu 35 Tage voraus (die Begruendung fuer die 35 steht
       weiter unten an der Schleife); findet sich in dieser Zeit kein
       Fenster, bleibt die Zeile leer statt eine falsche Auskunft zu
       geben. */
    var nextEl = badge.querySelector('[data-byg-status-next]');
    if (nextEl) {
      var kurz = ['', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
      function hhmm(min) {
        var h = Math.floor(min / 60), m = min % 60;
        return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
      }
      var txt = '';
      if (open) {
        for (var o1 = 0; o1 < ranges.length; o1++) {
          if (now.minutes >= ranges[o1][0] && now.minutes < ranges[o1][1]) {
            txt = 'bis ' + hhmm(ranges[o1][1]);
            break;
          }
        }
      } else {
        /* heute noch ein spaeteres Fenster? */
        for (var h1 = 0; h1 < ranges.length; h1++) {
          if (ranges[h1][0] > now.minutes) { txt = 'öffnet um ' + hhmm(ranges[h1][0]); break; }
        }
        /* sonst den naechsten Tag mit einem Fenster suchen.
           BIS ZU 35 TAGE, nicht 7: ein Betriebsurlaub von zwei oder
           drei Wochen hat innerhalb einer Woche kein offenes Fenster,
           und dann waere diese Zeile leer — genau dann, wenn jemand
           am dringendsten wissen will, wann wieder offen ist.
           Ohne Datum (Browser ohne Intl-Datumsteile) bleibt es bei
           den alten 7 Tagen und ohne Sonderzeiten: dann ist die
           Wochenlogik die einzige belegte Quelle. */
        if (!txt) {
          var maxTage = now.iso ? 35 : 7;
          for (var d = 1; d <= maxTage; d++) {
            var tag, r2;
            if (now.iso) {
              var iso2 = isoPlus(now.iso, d);
              tag = isoWeekday(iso2);
              r2 = zeitenFuer(root, sonderListe, tag, iso2).ranges;
            } else {
              tag = ((now.day - 1 + d) % 7) + 1;
              r2 = parseRanges(root.getAttribute('data-zeit-' + tag) || '');
            }
            if (r2.length) {
              /* Innerhalb der ersten Woche sagt der Wochentag mehr als
                 ein Datum ("öffnet Do 08:00"). Danach nicht mehr — "Do"
                 waere dann zweideutig, also kommt das Datum dazu. */
              var wann;
              if (d === 1) wann = 'morgen';
              else if (d <= 6) wann = kurz[tag];
              else wann = kurz[tag] + ' ' + kurzDatum(isoPlus(now.iso, d), now.iso.slice(0, 4));
              txt = 'öffnet ' + wann + ' ' + hhmm(r2[0][0]);
              break;
            }
          }
        }
      }
      nextEl.textContent = txt;
    }

    /* ---------- Hinweisstreifen über den Zeiten ----------
       Zeigt den Eintrag, der gerade laeuft, sonst den naechsten
       innerhalb des Vorlaufs. Liegt nichts an, bleibt der Streifen
       [hidden] — eine leere Zeile im Fuss sieht nach Fehler aus. */
    var sonderEl = root.querySelector('[data-byg-sonder]');
    if (sonderEl && now.iso) {
      var vorlauf = parseInt(root.getAttribute('data-sonder-vorlauf'), 10);
      if (!(vorlauf >= 1)) vorlauf = 28;
      var grenze = isoPlus(now.iso, vorlauf);
      var jahr = now.iso.slice(0, 4);
      var treffer = null;
      for (var si = 0; si < sonderListe.length; si++) {
        var e = sonderListe[si];
        if (e.bis < now.iso) continue;            /* vorbei */
        if (e.von > grenze) continue;             /* noch zu weit weg */
        if (!treffer || e.von < treffer.von) treffer = e;
      }
      if (treffer) {
        var spanne = kurzDatum(treffer.von, jahr);
        if (treffer.bis !== treffer.von) spanne += '–' + kurzDatum(treffer.bis, jahr);
        var was = treffer.grund || (treffer.zu ? 'geschlossen' : 'andere Zeiten');
        sonderEl.innerHTML = '';
        var b = document.createElement('b');
        b.textContent = spanne;
        sonderEl.appendChild(b);
        sonderEl.appendChild(document.createTextNode(' · ' + was));
        sonderEl.hidden = false;
      } else {
        sonderEl.textContent = '';
        sonderEl.hidden = true;
      }
    }

    /* Heutige Zeile in der Zeiten-Liste dezent markieren.
       is-sonder kommt dazu, wenn eine Sonderzeit heute uebersteuert:
       sonst stuende im Hinweisstreifen "Betriebsurlaub" und zwei
       Zentimeter darunter in fettem Violett "08:00–17:00". Die Zeile
       wird durchgestrichen statt entfernt — sie bleibt als Belegt,
       gilt aber sichtbar nicht. */
    var istSonder = !!heute.sonder;
    var rows = root.querySelectorAll('.byg-footer__ws-row');
    for (var r = 0; r < rows.length; r++) {
      var days = (rows[r].getAttribute('data-days') || '').split(',');
      var heuteZeile = days.indexOf(String(now.day)) !== -1;
      rows[r].classList.toggle('is-today', heuteZeile);
      rows[r].classList.toggle('is-sonder', heuteZeile && istSonder);
    }
  }

  /* ============================================================
     KARTE ERST NACH KLICK + AUSSCHNITT UMSCHALTEN (Umkreis / Zufahrt)
     15.10.2026: vorher stand die weite Ansicht als iframe im Markup und
     lud beim Hinscrollen. Jetzt gibt es bis zum Klick auf den Lade-Knopf
     kein iframe und damit keine Verbindung zu Google.
     ============================================================ */
  function initMap(root) {
    var map = root.querySelector('[data-byg-map]');
    if (!map) return;
    var tabs = root.querySelector('[data-byg-map-tabs]');
    var laden = map.querySelector('[data-byg-map-load]');
    var weit = map.getAttribute('data-src-weit') || '';
    var nah = map.getAttribute('data-src-nah') || '';
    var titel = map.getAttribute('data-map-title') || 'Karte';
    var btns = tabs ? tabs.querySelectorAll('[data-byg-map-view]') : [];
    var ansicht = 'weit';
    var geladen = false;

    function markiere(view) {
      ansicht = view;
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i].getAttribute('data-byg-map-view') === view;
        btns[i].classList.toggle('is-on', on);
        btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    function zeige(view) {
      var src = view === 'nah' && nah ? nah : weit;
      if (!src) return;
      var alt = map.querySelector('iframe');
      /* Das ELEMENT wird getauscht, nicht sein src. Eine src-Zuweisung
         auf ein stehendes iframe legt einen History-Eintrag an; der
         Zurueck-Knopf blaettert danach durch Kartenansichten statt die
         Seite zu verlassen. */
      var neu = document.createElement('iframe');
      neu.setAttribute('src', src);
      neu.setAttribute('title', titel);
      /* eager: der Besucher hat gerade geklickt, er wartet darauf. */
      neu.setAttribute('loading', 'eager');
      neu.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      neu.setAttribute('allowfullscreen', '');
      if (alt && alt.parentNode) alt.parentNode.replaceChild(neu, alt);
      else map.appendChild(neu);
      markiere(view);
    }

    /* Lädt die gewählte Ansicht genau einmal — per Klick oder (17.10.2026)
       automatisch. Der Knopf liegt danach unter der Karte und kommt aus
       der Tab-Reihenfolge, damit der Fokus nicht auf Unsichtbares springt. */
    function lade(mitFokus) {
      if (geladen || !weit) return;
      geladen = true;
      zeige(ansicht);
      map.classList.add('is-geladen');
      if (laden) laden.hidden = true;
      if (!mitFokus) return;
      var frame = map.querySelector('iframe');
      if (frame) { try { frame.focus({ preventScroll: true }); } catch (err) { /* egal */ } }
    }

    if (laden && weit) {
      laden.addEventListener('click', function (e) {
        e.preventDefault();
        lade(true);
      });
    }

    /* 17.10.2026 — AUTOMATIK. Erst kurz bevor die Werkstattkarte ins Bild
       kommt (1200 px Vorlauf, etwa anderthalb Bildschirme), damit die
       Karte beim Hinscrollen schon steht, aber nicht auf jeder Seite
       sofort mitgeladen wird. */
    if (weit && map.getAttribute('data-byg-map-auto') === '1') {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var k = 0; k < entries.length; k++) {
            if (entries[k].isIntersecting) { lade(false); io.disconnect(); break; }
          }
        }, { rootMargin: '1200px 0px' });
        io.observe(map);
      } else {
        lade(false);
      }
    }

    /* Ohne zweite Quelle gibt es nichts umzuschalten — dann bleiben
       die Chips weg, statt einen toten Knopf anzubieten. */
    if (!tabs || !weit || !nah || weit === nah) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var view = this.getAttribute('data-byg-map-view');
        if (view === ansicht && (geladen || this.classList.contains('is-on'))) return; /* schon da */
        if (geladen) zeige(view);
        else markiere(view); /* vor dem Laden: nur auswählen, nichts laden */
      });
    }
    tabs.hidden = false;
  }

  function initCopy(root) {
    var btn = root.querySelector('[data-byg-copy]');
    if (!btn) return;
    var supported = false;
    try {
      supported = !!(navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext);
    } catch (e) { /* Zugriff kann in Sonderkontexten werfen → Button bleibt versteckt */ }
    if (!supported) return; /* Fallback: Button bleibt [hidden] */

    btn.hidden = false;
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(btn.getAttribute('data-copy') || '').then(function () {
        var label = btn.querySelector('[data-byg-copy-label]');
        if (!label) return;
        if (!btn.dataset.origLabel) btn.dataset.origLabel = label.textContent;
        label.textContent = btn.getAttribute('data-label-done') || 'Kopiert!';
        btn.classList.add('is-done');
        window.clearTimeout(btn._bygCopyTimer);
        btn._bygCopyTimer = window.setTimeout(function () {
          label.textContent = btn.dataset.origLabel;
          btn.classList.remove('is-done');
        }, 2000);
      }).catch(function () { /* verweigert (Berechtigung) → kein Feedback, kein Fehler */ });
    });
  }

  function initRoot(root) {
    if (root.dataset.bygInit === '1') return;
    root.dataset.bygInit = '1';
    updateStatus(root);
    initCopy(root);
    initMap(root);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-byg-werkstatt]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Status minütlich auffrischen (Badge kippt z. B. um 12:00 ohne Reload).
     Läuft über querySelectorAll auf dem lebenden DOM — kein Leak bei
     Section-Re-Renders im Theme-Editor. */
  window.setInterval(function () {
    var roots = document.querySelectorAll('[data-byg-werkstatt]');
    for (var i = 0; i < roots.length; i++) updateStatus(roots[i]);
  }, 60000);

  /* Theme-Editor: Section wird neu gerendert → neu initialisieren. */
  document.addEventListener('shopify:section:load', initAll);
})();
